import { Link, useNavigate, useParams } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { useActiveStore } from "@/hooks/use-active-store";
import { useProduct } from "@/hooks/use-products";
import { ProductForm } from "@/components/products/product-form";

export function EditProductPage() {
  const { productId } = useParams({ strict: false }) as { productId: string };
  const navigate = useNavigate();
  const { storeId } = useActiveStore();
  const { data: product, isLoading } = useProduct(storeId, productId);

  if (isLoading) {
    return (
      <div className="p-4 flex flex-col gap-3">
        <Skeleton className="h-5 w-48" />
        <Skeleton className="h-64 w-full" />
      </div>
    );
  }

  return (
    <div className="p-4 flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <Link to="/products" className="text-muted-foreground hover:text-foreground">
          <ArrowLeft className="h-4 w-4" />
        </Link>
        <h2 className="text-sm font-medium">Uredi proizvod</h2>
      </div>
      <ProductForm product={product} onSuccess={() => navigate({ to: "/products" })} />
    </div>
  );
}
